<template>
  <v-container fluid style="height: 85dvh; overflow-y: auto">
    <EmployeePTPayrollView
      ref="employeePTPayrollView"
      :user="user"
      :companies="companiesList"
      :myPTSubmissions="myPTSubmissions"
      :ptFormStatus="ptFormStatus"
      @submitPT="handlePTPayrollSubmission"
      @refresh="loadPTData"
    />
  </v-container>
</template>

<script>
import EmployeePTPayrollView from "./components/EmployeePTPayrollView.vue";

export default {
  name: "PTPayrollComponent",
  components: {
    EmployeePTPayrollView,
  },
  inject: ["users", "companies"],
  data() {
    return {
      // PT-specific data
      myPTSubmissions: [],
      ptFormStatus: {
        hasEmployeeDatabaseForm: false,
        hasSignatureAcknowledgement: false,
      },
    };
  },
  computed: {
    user() {
      // Get user from Vuex store
      return this.$store?.state?.auth?.user || null;
    },
    usersList() {
      return this.users ? this.users() : [];
    },
    companiesList() {
      return this.companies ? this.companies() : [];
    },
  },
  mounted() {
    this.loadPTData();
  },
  methods: {
    async loadPTData() {
      try {
        // Load employee's own PT submissions
        const ptSubmissionsResponse = await this.$axios.get('/api/payroll/pt/my-submissions');
        if (ptSubmissionsResponse.data.response || ptSubmissionsResponse.data.data) {
          this.myPTSubmissions = ptSubmissionsResponse.data.data || [];
        }

        // Load PT form status (one-time forms)
        const ptFormStatusResponse = await this.$axios.get('/api/payroll/pt/form-status');
        if (ptFormStatusResponse.data.response && ptFormStatusResponse.data.data) {
          this.ptFormStatus = ptFormStatusResponse.data.data;
        }
      } catch (error) {
        console.error('Error loading PT data:', error);
        this.$toast.error('Failed to load PT payroll data');
      }
    },

    async handlePTPayrollSubmission(payload) {
      try {
        const formData = new FormData();
        
        // Add all fields to FormData
        if (payload.company?.id) {
          formData.append('company_id', payload.company.id);
        }
        formData.append('client_name', payload.clientName);
        formData.append('invoice_number', payload.invoiceNumber);
        formData.append('invoice_period_from', payload.invoicePeriod.from);
        formData.append('invoice_period_to', payload.invoicePeriod.to);
        formData.append('hours_worked', payload.hoursWorked.hours + (payload.hoursWorked.minutes / 60));
        formData.append('invoice_amount', payload.invoiceAmount);
        formData.append('currency', payload.currency || 'USD');
        
        // Add required invoice file
        if (payload.invoiceFile) {
          formData.append('invoice_file', payload.invoiceFile);
        }
        
        // Add PT-specific files
        if (payload.capacityUtilizationFile) {
          formData.append('capacity_utilization_form_file', payload.capacityUtilizationFile);
        }
        if (payload.overtimeApprovalFile) {
          formData.append('overtime_approval_file', payload.overtimeApprovalFile);
        }
        if (payload.employeeDatabaseFormFile) {
          formData.append('employee_database_form_file', payload.employeeDatabaseFormFile);
        }
        if (payload.signatureAcknowledgementFile) {
          formData.append('signature_acknowledgement_file', payload.signatureAcknowledgementFile);
        }
        if (payload.receiptFile) {
          formData.append('acknowledgement_receipt_file', payload.receiptFile);
        }
        if (payload.corFile) {
          formData.append('cor_file', payload.corFile);
        }
        if (payload.taxReturnFiles && payload.taxReturnFiles.length) {
          payload.taxReturnFiles.forEach((file) => {
            formData.append('tax_return_files[]', file);
          });
        }
        
        // Add Time Doctor hours for backend validation
        if (payload.timeDoctorHours !== null && payload.timeDoctorHours !== undefined) {
          formData.append('time_doctor_hours', payload.timeDoctorHours);
        }
        
        // Add optional comments
        if (payload.comments) {
          formData.append('comments', payload.comments);
        }

        const response = await this.$axios.post('/api/payroll/pt/submit', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        if (response.data.response) {
          this.$toast.success(response.data.message || 'PT Payroll submitted successfully');
          // Show success confirmation in EmployeePTPayrollView
          if (this.$refs.employeePTPayrollView) {
            this.$refs.employeePTPayrollView.showPTSubmissionSuccess();
          }
          // Reload PT data
          await this.loadPTData();
        } else {
          this.$toast.error(response.data.message || 'Failed to submit PT payroll');
          if (this.$refs.employeePTPayrollView) {
            this.$refs.employeePTPayrollView.enableSubmit();
          }
        }
      } catch (error) {
        console.error('Error submitting PT payroll:', error);
        this.$toast.error(error.response?.data?.message || 'Failed to submit PT payroll');
        if (this.$refs.employeePTPayrollView) {
          this.$refs.employeePTPayrollView.enableSubmit();
        }
      }
    },
  },
};
</script>
